<div class="flex min-h-0 flex-1 flex-col">
    <div *ngIf="!isUnassignedSelected && !isLoading" class="shrink-0 bg-white pb-12">
        <p class="mb-4 text-sm font-medium text-darktextcolor">{{ 'USERS.FILTER.TEAM_ROLE.SHOW_PEOPLE_WHO_ARE' | translate }}</p>
        <div class="team-role-options" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
            <mat-checkbox
                *ngFor="let option of teamRoleOptions"
                [checked]="option.selected"
                (change)="onTeamRoleChange(option, $event.checked)"
            >
                {{ option.translationKey | translate }}
            </mat-checkbox>
        </div>
    </div>

    <div class="team-filter-body flex min-h-0 flex-1 flex-col" *ngIf="!isLoading; else tableShimmer">
        <div class="table-actions-wrapper flex min-h-0 flex-1 flex-col" [class.disabled]="!isTableActive">
            <div fxLayoutAlign="space-between center" class="mb-24 shrink-0">
                <h3 class="mb-0">{{ 'TEAMS.TITLE.SINGULAR' | translate }}</h3>

                <app-search-outline [searchInput]="searchInput"></app-search-outline>
            </div>

            <div class="table-wrapper" *ngIf="isSearchActive; else treeView">
                <div class="search-results-wrapper" *ngIf="!isSearchLoading; else searchShimmer">
                    <div class="team-filter-container-table" *ngIf="searchResults.length; else noSearchResults">
                        <div
                            *ngFor="let team of searchResults"
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            class="search-result-row p-12 pr-24"
                            [attr.data-team-selected-row]="team.isSelected ? true : null"
                        >
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                    <mat-icon svgIcon="team"></mat-icon>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="center start">
                                    <h3 class="mb-4">{{ team.name }}</h3>
                                    <div class="text-sm text-gray-500" fxLayout="row" *ngIf="team.breadcrumbs?.length > 1">
                                        <span *ngFor="let breadcrumb of team.breadcrumbs; let i = index">
                                            <ng-container *ngIf="i < team.breadcrumbs.length - 1">
                                                {{ breadcrumb.name }}<ng-container *ngIf="i < team.breadcrumbs.length - 2">&nbsp;/&nbsp;</ng-container>
                                            </ng-container>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(team); onSelection()" *ngIf="!team.isSelected"></app-flat-button>

                            <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(team); onSelection()" *ngIf="team.isSelected"></app-white-button>
                        </div>
                    </div>

                    <ng-template #noSearchResults>
                        <div fxLayout="column" fxLayoutAlign="center center" class="py-48">
                            <mat-icon class="mb-8 text-hint" svgIcon="search_illustration"></mat-icon>
                            <p>{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</p>
                        </div>
                    </ng-template>
                </div>

                <ng-template #searchShimmer>
                    <div class="search-results-wrapper">
                        <div class="shimmer-container py-24 px-12">
                            <div class="shimmer" *ngFor="let item of [1, 2, 3]">
                                <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                                    <div class="shimmer-title w-100-p animate mb-0"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <mat-paginator
                    *ngIf="searchResults.length"
                    [length]="searchTotalCount"
                    [pageSize]="searchPageSize"
                    [pageIndex]="searchPageIndex"
                    (page)="onSearchPageChange($event)"
                ></mat-paginator>
            </div>

            <ng-template #treeView>
                <div #teamFilterScrollArea class="team-filter-container" fxLayout="column" fxLayoutAlign="start">
                    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
                        <mat-tree-node *matTreeNodeDef="let node">
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p p-12 pr-24" [attr.data-team-selected-row]="node.isSelected ? true : null">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <button class="mr-8" mat-icon-button>
                                        <mat-icon class="circle">circle</mat-icon>
                                    </button>
                                    <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                        <mat-icon svgIcon="team"></mat-icon>
                                    </div>
                                    <h3>{{ node.name }}</h3>
                                </div>

                                <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(node); onSelection()" *ngIf="!node.isSelected"></app-flat-button>

                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node); onSelection()" *ngIf="node.isSelected"></app-white-button>
                            </div>
                        </mat-tree-node>

                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-12 pr-24" [attr.data-team-selected-row]="node.isSelected ? true : null">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <button mat-icon-button class="mr-8" (click)="toggleNode(node)" [attr.aria-label]="'Toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                        </mat-icon>
                                    </button>
                                    <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center">
                                        <mat-icon svgIcon="team"></mat-icon>
                                    </div>
                                    <h3 class="mb-12">{{ node.name }}</h3>
                                </div>

                                <app-flat-button [label]="'GENERAL.BUTTON.SELECT'" (onClick)="addToList(node); onSelection()" *ngIf="!node.isSelected"></app-flat-button>

                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="removeFromList(node); onSelection()" *ngIf="node.isSelected"></app-white-button>
                            </div>

                            <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                                <div *ngIf="node.isLoading" class="shimmer-container pb-4 pt-12">
                                    <div class="shimmer" *ngFor="let item of [1, 2, 3]">
                                        <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                                            <div class="shimmer-square animate mr-12"></div>
                                            <div class="shimmer-title w-100-p animate mb-0"></div>
                                        </div>
                                    </div>
                                </div>
                                <ng-container matTreeNodeOutlet></ng-container>
                            </div>
                        </mat-nested-tree-node>
                    </mat-tree>
                </div>
            </ng-template>
        </div>

        <mat-checkbox class="mt-24 shrink-0" [(ngModel)]="isUnassignedSelected" (change)="onSelection()" *ngIf="!isSearchActive">
            {{ 'GENERAL.LABEL.UNASSIGNED_TEAM' | translate }}
        </mat-checkbox>
    </div>
</div>
<ng-template #tableShimmer>
    <div class="team-filter-body flex min-h-0 flex-1 flex-col">
        <div fxLayoutAlign="space-between center" class="mb-24 shrink-0">
            <h3 class="mb-0">{{ 'TEAMS.TITLE.SINGULAR' | translate }}</h3>
        </div>
        <div class="team-filter-container filter-table-shimmer">
            <div class="shimmer-container py-16 px-16">
                <div class="shimmer" *ngFor="let item of [1, 2, 3, 4, 5, 6]">
                    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                        <div class="shimmer-title w-100-p animate mb-0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
